import React from "react";
import "./Footer.css";
import { Fade } from "react-reveal";
import { made } from "../../portfolio.js";

/* eslint-disable jsx-a11y/accessible-emoji */

export default function Footer(props) {
  const currentYear = new Date().getFullYear(); // Get the current year

  return (
    <div className="footer-div">
      <Fade>
        <p
          className="footer-text"
          style={{ color: props.theme.secondaryText, textDecoration: "none" }} // Corrected the style here
        >
          Copyright &copy; {currentYear} | Managed{" "}
          {/* <span role="img" aria-label="love">
            ❤️
          </span>{" "} */}
          by{" "}
         <a
  href={made.url || "#"} 
  target="_blank"
  rel="dofollow noopener noreferrer"
  style={{
    color: "red",
    textDecoration: "none",
  }}
>
            {made.title}
          </a>
        </p>
      </Fade>
    </div>
  );
}
